module.exports = __webpack_public_path__ + "assets/img/btn_chip_4.d3a1a982.png";